var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTeamwork = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 222,
  height: 160
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#222747",
  d: "M99.31 113.649v30.306h-35.9l-1.063-27.612z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#303D72",
  d: "M57.679 44.123 51.284 79.14l-22.066 1.611s-1.12 2.99-.56 5.43l.56 2.438s24.388.437 28.35-.867 3.943-33.057 3.872-36.546c-.07-3.49-3.761-7.084-3.761-7.084zm35.365-1.783 17.258 13.984 31.604-5.6s2.073 4.016 2.229 5.509l.155 1.496s-31.17 9.308-35.218 9.12c-4.047-.187-19.114-12.197-19.114-12.197z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#303D72",
  d: "m70.037 38.774-12.588 5.37.817 74.519s24.19 4.762 33.73 2.304l9.541-2.468-6.784-74.148a2.89 2.89 0 0 0-2.168-2.53l-11.238-2.899z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#26335E",
  d: "m57.449 55.71.68 62.516s19.139 3.768 30.048 2.858L57.45 55.71z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E68D5C",
  d: "m116.496 72.517-1.632 17.743-13.772 25.667 4.362 2.179 18.603-26.075.638-20.276z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#303D72",
  d: "M151.182 128.511s.678 6.175.678 9.08c0 2.904-1.305 7.256-1.305 7.256h-22.297l1.616-18.273z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#0CBFD1",
  d: "M114.452 72.067s1.963-11.825 5.654-15.127c2.647-2.374 5.228-2.307 7.031-1.91 1.803.399 3.467 6.41 1.711 14.52-1.207 5.62-1.364 6.21-1.364 6.21s-9.5.31-13.032-3.693"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#60D6E6",
  d: "m139.705 50.362 14.828 6.533-2.724 71.907h-36.02l3.244-70.573a4.03 4.03 0 0 1 2.058-3.317l7.854-4.404z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E2E2E2",
  d: "m64.295 88.245 3.126 30.297 33.45 13.878s2.501 2.875 0 6.633L63.238 128.35z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F0F1F4",
  d: "m43.025 81.336-11.27 4.362a5.08 5.08 0 0 0-3.25 4.903l1.739 55.137h35.22l-.858-56.595a6.34 6.34 0 0 0-4.28-5.915l-7.482-2.56z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#303D72",
  d: "M184.37 48.134h1v98.05h-1zm4.899 9.805h1v86.017h-1zm-1.336 17.827h1v70.864h-1zm-8.462 14.708h1v56.156h-1zm12.47 15.598h1v39.666h-1z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#303D72",
  d: "M178.789 68.713c5.105-2.658 10.859-1.462 12.889 2.672s-.45 9.626-5.529 12.295-15.886 12.6-17.916 8.48 5.469-20.79 10.556-23.447m-7.209 52.64c4.575-4.791 12.433-4.941 17.553-.327s5.554 12.23.978 17.027c-4.575 4.797-11.542 20.366-16.659 15.755s-6.448-27.661-1.872-32.455"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00C99C",
  d: "M168.253 92.37c6.077-4.15 13.633-3.604 16.874 1.224s.945 12.116-5.129 16.258-18.279 18.33-21.522 13.505c-3.244-4.825 3.702-26.837 9.777-30.987"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00B98F",
  d: "M168.308 92.347c-5.747 3.88-12.269 23.463-10.3 29.77 5.305-15.989 8.751-20.719 14.245-26.529a26.8 26.8 0 0 1 7.664-5.637c-3.527-.91-7.85-.142-11.61 2.396z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00C99C",
  d: "M203.105 73.05c-7.058-2.336-14.26.314-16.085 5.909-1.824 5.594 2.414 12.03 9.472 14.363 7.06 2.333 22.842 12.7 24.666 7.102s-10.997-25.042-18.053-27.374"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00B98F",
  d: "M203.016 72.59c6.673 2.17 18.485 19.29 18.316 25.906-9.616-13.974-14.287-17.594-21.252-21.694a27.3 27.3 0 0 0-9.03-3.344c3.193-1.837 7.601-2.284 11.966-.867z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E2E2E2",
  d: "m28.502 103.806 1.33 41.932h35.187l-.333-10.245-29.12-15.9 2.637-21.097z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00C99C",
  d: "M194.72 51.722c-4.508 1.845-6.95 6.14-5.459 9.593s6.355 4.763 10.86 2.918c4.506-1.845 16.79-3.492 15.298-6.948s-16.193-7.405-20.698-5.563z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#303D72",
  d: "M185.404 40.371c2.757 1.976 3.781 5.415 2.288 7.68-1.493 2.266-4.932 2.5-7.686.524s-10.74-4.94-9.26-7.203 11.905-2.973 14.658-1z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00B98F",
  d: "M194.902 51.715c4.311-1.706 17.8 1.634 20.642 4.865-10.99-2.734-14.95-2.545-20.259-1.643a18.9 18.9 0 0 0-6.016 2.11c.788-2.187 2.813-4.215 5.633-5.332"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#A9C2DC",
  d: "M0 142.618h214.653v2.674H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#303D72",
  d: "M0 145.292h214.653v1.783H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00C99C",
  d: "M169.066 129.149c6.418-3.622 13.958-2.513 16.849 2.482 2.89 4.994.03 11.976-6.384 15.598s-19.745 16.643-22.642 11.642c-2.897-5 5.763-26.098 12.177-29.722"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00B98F",
  d: "M169.488 129.174c-6.03 3.453-14.03 22.588-12.55 29.043 6.508-15.613 10.313-20.093 16.237-25.494a26.9 26.9 0 0 1 8.078-5.075c-3.452-1.17-7.82-.732-11.765 1.526"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00C99C",
  d: "M208.946 109.793c-8.126-5.56-18.904-5.56-24.073.025-5.169 5.583-2.784 14.613 5.355 20.178s23.754 23.839 28.923 18.261c5.17-5.577-2.079-32.9-10.205-38.464"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00B98F",
  d: "M208.937 108.948c7.654 5.31 14.527 30.075 11 37.682-5.572-20.217-9.888-26.365-16.956-34.021a36.3 36.3 0 0 0-10.15-7.644c5.09-.809 11.088.519 16.106 3.983"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FBAD83",
  d: "M58.594 132.813s6.033 1.81 9.125 2.833 5.014 2.635 4.863 3.185-.377.668-.377.668H59.61l-5.279-3.167z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F0F1F4",
  d: "M29.178 87.354s-11.707 29.248-9.242 38.342c2.464 9.095 38.307 14.248 38.307 14.248s1.044-2.653 1.232-4.681l.2-2.03-31.316-10.93s10.068-20.555 10.62-27.153c.55-6.598-9.8-7.796-9.8-7.796z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#A9C2DC",
  d: "M80.606 139.499h48.4a1.92 1.92 0 0 0 1.924-1.918V103.98a1.92 1.92 0 0 0-1.923-1.918h-48.4V139.5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#19192B",
  d: "M80.606 139.499h.696c.845-.002 1.53-.768 1.531-1.714v-34.01c-.002-.946-.686-1.712-1.531-1.714h-.696V139.5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M103.764 121.003c0 2.348 1.297 4.234 2.896 4.234 1.6 0 2.893-1.896 2.893-4.234s-1.296-4.234-2.893-4.234-2.896 1.895-2.896 4.234"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#19192B",
  d: "M52.55 139.944h28.056v2.228H52.55z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#303D72",
  d: "M80.606 139.944h48.987v2.228H80.606z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#0CBFD1",
  d: "m150.913 128.802 2.284-61.459-5.951-1.382-14.09 62.841z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M42.307 81.325s2.738 4.767 6.937 4.69c4.198-.075 3.203-5.346 3.203-5.346z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F9C200",
  d: "M60.057 57.047s2.002 16.193 1.217 19.359c-.785 3.165-8.824 2.521-12.813 2.2-3.989-.323-6.113.215-7.86-.757s1.455-11.101 1.455-11.101l18.001-9.7z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M55.941 79.33c-2.578.06-4.787-1.85-5.128-4.434-.34-2.584 1.297-5.012 3.801-5.636a.16.16 0 0 1 .193.111.163.163 0 0 1-.11.198c-2.408.665-3.894 3.103-3.397 5.575.496 2.472 2.804 4.131 5.277 3.795s4.265-2.553 4.097-5.07-2.237-4.47-4.733-4.469a.16.16 0 0 1-.158-.16.16.16 0 0 1 .158-.16c2.8 0 5.07 2.295 5.07 5.125s-2.27 5.125-5.07 5.125"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FBAD83",
  d: "m52.995 74.507-.785 6.816s-.935 1.572-5.82 1.572A9 9 0 0 1 42.306 82V69.972z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E68D5C",
  d: "m53.44 73.69-.516 4.724c-.858.07-1.72 0-2.559-.203-1.106-.269-4.265-3.729-6.276-8.685l9.352 4.164z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FBAD83",
  d: "M59.286 52.986s1.123 11.249-.445 16.695-6.446 7.74-10.771 6.753c-1.603-.372-7.404-6.951-8.138-15.078-.733-8.128-.033-10.577 1.277-12.295 1.31-1.719 13.22-3.858 15.385-1.979s2.692 5.904 2.692 5.904"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F9C200",
  d: "M56.113 52.184s3.566 5.154 4.466 5.304 1-3.273.777-6.353c-.363-4.865-3.668-7.012-3.668-7.012z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F9C200",
  d: "M59.23 48.269s-1.11 6.174-3.44 9.866c-2.33 3.693-11.078 2.346-12.642 2.457S43.37 73.12 44.48 77.26s-6.88 2.907-9.432 2.35c-2.552-.559-3.885-22.37-.554-30.818s17.086-8.12 20.858-6.269a7 7 0 0 1 3.878 5.746"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FBAD83",
  d: "M39.635 67.015c0 1.565 2.005 2.957 3.234 2.957 1.228 0 1.22-1.392 1.22-2.957 0-1.566-.999-2.837-2.227-2.837-1.229 0-2.227 1.26-2.227 2.837"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E68D5C",
  d: "M40.553 66.624c.126-.743 1.104-1.208 1.634-1.09.53.116-.862.54-.988 1.28s.618 1.48.087 1.363c-.53-.117-.86-.813-.733-1.553"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F76A00",
  d: "M49.742 63.287a.31.31 0 0 1-.297-.209.28.28 0 0 1 .13-.326l2.714-1.647a.33.33 0 0 1 .245-.038l2.01.491c.167.041.266.2.222.356-.043.156-.213.249-.38.208l-1.877-.459-2.6 1.577a.33.33 0 0 1-.167.047m11.407-.891a.27.27 0 0 1-.159-.054l-1.408-1.035-1.764.528a.27.27 0 0 1-.284-.088.37.37 0 0 1-.075-.324.32.32 0 0 1 .21-.236l1.904-.564a.27.27 0 0 1 .233.043l1.516 1.115c.11.08.16.234.122.376-.037.143-.153.24-.283.239z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M42.579 79.316c-2.576.052-4.781-1.853-5.125-4.429-.343-2.575 1.284-5 3.782-5.637a.166.166 0 0 1 .086.32c-2.413.664-3.902 3.102-3.405 5.574s2.81 4.133 5.29 3.797c2.479-.337 4.274-2.554 4.106-5.071s-2.242-4.472-4.744-4.47a.16.16 0 0 1-.158-.16.16.16 0 0 1 .158-.16c2.807 0 5.082 2.295 5.082 5.126 0 2.83-2.275 5.125-5.082 5.125z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FBAD83",
  d: "M139.836 36.992v13.445s-2.342 1.919-6.462 1.689c-3.814-.212-4.418-1.532-4.418-1.532l-1.59-6.974 12.458-6.616"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E68D5C",
  d: "M128.61 49.903a15.8 15.8 0 0 0 4.097-2.568c1.863-1.502 3.26-3.55 4.012-5.887l-8.118 1.62-1.234.72 1.272 6.128"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1A2249",
  d: "M118.46 28.969h6.68v1h-6.68z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#7A4029",
  d: "M120.93 19.412s-1.134 3.017-1.134 5.656c0 2.126.798 6.13.798 6.13l4.546-12.48z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FBAD83",
  d: "M120.978 43.004c3.674 7.794 12.776 3.19 16.677-.742 3.902-3.93 3.369-18.952 2.282-21.798s-10.106-5.152-14.847-3.318-7.781 18.062-4.112 25.858"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D7C5BE",
  d: "M119.35 36.992a15.6 15.6 0 0 0 1.574 5.283c1.6 2.975 4.138 4.076 6.888 4.076-2.746 0-5.289-1.095-6.885-4.076a15.6 15.6 0 0 1-1.573-5.283"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D48C68",
  d: "M140.282 31.198h-4.08s-2.7 7.3-5.019 8.002a2 2 0 0 1-.57.078c-1.933 0-4.503-2.418-7.747-2.559-.304 0-.572-.022-.818-.022-1.388 0-2.01.213-2.697.692a18.5 18.5 0 0 0 1.425 5.563c1.446 3.132 3.748 4.29 6.236 4.29 3.77 0 7.975-2.643 10.305-5.042 1.871-1.926 2.713-6.483 2.959-11.002"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#7A4029",
  d: "M140.142 31.934a5.04 5.04 0 0 1-3.445-1.81 4.83 4.83 0 0 1-1.065-3.682c.21-1.66.71-2.192.27-3.763-.864-3.137-4.722-2.842-7.313-1.669s-5.421 1.167-7.652-.483c-1.062-.784-2.398-2.97-.953-5.252 1.444-2.283 6.583-5.024 6.583-5.024s-.622 1.37-.417 2.082c.205.71 13.859-3.304 16.655 2.632s-.932 17.124-.932 17.124l-1.73-.155z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FBAD83",
  d: "M142.063 32.015c0 1.928-2.612 3.64-4.214 3.64s-1.575-1.712-1.575-3.64 1.3-3.491 2.902-3.491 2.887 1.563 2.887 3.491"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E68D5C",
  d: "M140.26 32.154c.176.918-.777 1.992-1.456 2.15-.68.158.783-1.096.605-2.015s-1.382-1.354-.703-1.512c.68-.158 1.377.458 1.555 1.377z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1A2249",
  fillRule: "nonzero",
  d: "M121.132 33.426c-1.473 0-2.672-1.499-2.672-3.342 0-1.844 1.199-3.343 2.672-3.343s2.672 1.499 2.672 3.343-1.214 3.342-2.672 3.342m0-6.39c-1.305 0-2.367 1.366-2.367 3.048s1.062 3.048 2.367 3.048c1.306 0 2.367-1.37 2.367-3.048 0-1.68-1.077-3.049-2.367-3.049zm6.235 6.39c-1.473 0-2.672-1.499-2.672-3.342 0-1.844 1.199-3.343 2.672-3.343s2.672 1.499 2.672 3.343-1.199 3.342-2.672 3.342m0-6.39c-1.306 0-2.367 1.366-2.367 3.048s1.061 3.048 2.367 3.048c1.305 0 2.367-1.37 2.367-3.048 0-1.68-1.062-3.049-2.367-3.049z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1A2249",
  d: "M130.039 28.969h6.68v1h-6.68zm-6.68 0h1.781v1h-1.781z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M121.577 39.22h5.345s-1.072 2.602-2.887 2.673c-1.816.07-2.458-2.673-2.458-2.673"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FBAD83",
  d: "m159.902 71.755-8.949 3.111 4.32 17.563-9.596 37.787-2.722 1.62s-.154 4.045 2.817 4.823 4.049-1.437 4.049-1.437v-2.965c2.379-6.061 14.317-36.545 14.502-38.512.207-2.184-4.421-21.99-4.421-21.99"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#60D6E6",
  d: "M150.633 75.771s-3.419-10.44-1.983-14.652c1.035-3.037 3.033-4.06 4.573-4.488 1.54-.426 5.303 3.77 7.343 11.093 1.412 5.072 1.537 5.617 1.537 5.617s-7.11 4.215-11.47 2.43"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#A55B3A",
  d: "M142.517 50.798s.95-.98 3.397 0 2.94 2.588 2.81 4.199-3.12 2.427-5.01 1.882c-1.888-.546-3.56-2.67-3.425-3.533.137-.862 2.228-2.548 2.228-2.548M28.421 89.793c-1.113-.67-1.872-1.756-2.085-2.988a4.2 4.2 0 0 1 .97-3.46q.148-.174.318-.35c2.184-2.289 4.22-2.153 5.967-1.349 1.747.805 1.326 4.408-.127 6.249s-4.02 2.467-4.928 1.967z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "m69.473 38.774 3.968 5.349 4.123-2.86 4.378 2.009-.586-4.344z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#A55B3A",
  d: "M69.918 24.067v14.239s2.429 2.029 6.702 1.785c3.951-.225 4.579-1.633 4.579-1.633l1.634-7.386z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#8E4A2F",
  d: "M81.434 37.337c-2.191.485-4.724-.87-6.616-2.365-3.489-2.754-4.9-8.231-4.9-8.231l11.542 3.448 1.373.75z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1A2249",
  d: "M89.53 7.003s1.889.723 1.758 5.358c-.064 2.192-.862 6.358-.862 6.358L85.505 5.794z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#A55B3A",
  d: "M90.008 30.278c-3.899 8.249-13.575 3.374-17.721-.782s-3.57-20.047-2.422-23.062S80.587.98 85.639 2.924c5.052 1.945 8.267 19.102 4.369 27.354"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1A2249",
  d: "M75.287 16.936s1.09 9.133 3.61 9.864c2.164.613 5.146-2.428 9.025-2.59 2.164-.093 2.94.11 3.818.699a18.7 18.7 0 0 1-1.546 5.813c-3.95 8.252-13.754 3.375-17.955-.783-2.021-2.02-2.949-6.785-3.212-11.505z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1A2249",
  d: "M73.384 20.845s1.187.124 1.671-.616c.485-.74-.908-4.918.5-9.351 1.003-3.175 5.56-4.995 9.291-4.226 3.732.768 4.67 1.114 5.052-.022s-1.118-3.81-2.423-4.868C86.17.705 80.113-1.166 75.058 1s-6.056 3.604-7.201 7.04-.403 12.043 0 12.592 5.527.213 5.527.213"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#A55B3A",
  d: "M67.246 19.744c0 2.288 3.006 4.323 4.85 4.323s1.83-2.035 1.83-4.323-1.494-4.145-3.341-4.145-3.339 1.856-3.339 4.145"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1A2249",
  d: "M91.294 24.958s0 9.825-1.183 11.598-5.065 2.156-6.822 1.417-4.623-3.404-5.323-5.659 10.403-5.487 10.403-5.487z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#8E4A2F",
  d: "M68.604 18.337c-.178.917.775 1.99 1.456 2.15s-.783-1.094-.606-2.014 1.384-1.352.703-1.512-1.378.459-1.553 1.376"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M89.513 28.823s-4.014.101-4.682-.1l-.662-.2s.018 1.852 1.88 2.491c1.86.639 2.88-.54 3.129-1.193s.335-.998.335-.998"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1A2249",
  d: "M88.477 15.588a.31.31 0 0 1-.296-.262.32.32 0 0 1 .196-.35 6.06 6.06 0 0 1 3.573 0 .31.31 0 0 1 .225.226.32.32 0 0 1-.086.312.3.3 0 0 1-.306.068 5.6 5.6 0 0 0-3.206 0 .3.3 0 0 1-.1.006m-7.579.902a.28.28 0 0 1-.192-.072.305.305 0 0 1-.029-.421c.07-.08 1.707-1.979 4.625-1.02a.3.3 0 0 1 .196.221.3.3 0 0 1-.087.286.28.28 0 0 1-.284.065c-2.545-.837-3.953.77-4.011.84a.29.29 0 0 1-.218.101"
}))));
export default SvgTeamwork;